import React, {Component} from "react";
import {Helmet} from "react-helmet";

import layoutStyles from "./index.module.pcss";

class Layout extends Component {
  componentDidMount() {
    if (typeof window !== 'undefined' && window) {
      require("cookieconsent");
      require("cookieconsent/build/cookieconsent.min.css");

      window.addEventListener("load", () => {
        return this.initCookiConsent();
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("load");
  }

  initCookiConsent = () => {
    window.cookieconsent.initialise(this.getCookieConsentOptions())
  };

  getCookieConsentOptions = () => {
    const {location} = this.props;

    const isEnglish = _.chain(location.pathname)
                       .split("/")
                       .compact()
                       .includes("en")
                       .value();

    const link = isEnglish ? "Learn more." : "Weitere Informationen.";
    const message = isEnglish
      ? "By continuing to browse this site, you are agreeing to the use of cookies and our privacy policy."
      : "Durch die weitere Nutzung der Seite stimmen Sie der Verwendung von Cookies und unseren Datenschutzbestimmungen zu."

    return {
      "palette": {
        "popup": {
          "background": "#232323"
        },
        "button": {
          "background": "transparent",
          "text": "#2399dd",
          "border": "#2399dd"
        }
      },
      content: {
        link: link,
        href: 'http://campudus.com/impressum',
        message: message,
        dismiss: "Ok",
      }
    };
  }

  render() {
    const {children} = this.props;
    // depending on which context is reading the index.js file (gatsby or storybook)
    // the children have to be called as a function or not
    const callChildren = typeof children === "function" ? children() : children;

    const styleString = ".cc-link {color: #2399dd !important; opacity: 1 !important; text-decoration: none !important;}";

    return (
      <div className={layoutStyles.layout}>
        <Helmet>
          <style id="cookie-consent-css">{styleString}</style>
        </Helmet>
        {callChildren}
      </div>
    );
  }
}

export default Layout;



// WEBPACK FOOTER //
// ./src/layouts/index.js